<mat-card appearance="outlined">
  <mat-card-content>
    @if (!settingsService.settings$.value['navigation']['showChips']) {
      <mat-chip-listbox>
        <mat-chip-option selected color="accent" [disableRipple]="true">
          Heute geloggt: {{ timerService.totalTodayDurations | async }}
        </mat-chip-option>
        @if (timerService.beginningOfDay) {
          <mat-chip-option selected color="accent" [disableRipple]="true">
            Anfang des Tages: {{ timerService.beginningOfDay }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    }
    <div class="pinned-timers">
      <mat-expansion-panel
        [hideToggle]="true"
        [expanded]="panelIsExpanded"
        (expandedChange)="settingsService.saveSetting($event, 'panelExpanded', 'pinnedTimers')"
        >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>bookmarks</mat-icon>
            Gepinnte Timer
          </mat-panel-title>
        </mat-expansion-panel-header>

        <nx-pinned-timers></nx-pinned-timers>
        @if (timerService.pinnedTimers.length === 0) {
          <div class="placeholder-pinned-timers">
            Klicke auf
            <mat-icon>bookmark_border</mat-icon>
            um Timer zu pinnen!
          </div>
        }
      </mat-expansion-panel>
    </div>
    @if (autoStoppedTimer) {
      <div class="auto-stopped-timer-container">
        <p>
          <mat-icon>timer_off</mat-icon>
          Automatisch gestoppter Timer
        </p>
        <nx-timer
          [timer]="autoStoppedTimer"
          [expansionPanelDisabled]="true"
          [autoStopped]="true"
          class="pinned-timer"
          >
        </nx-timer>
      </div>
    }
  </mat-card-content>
</mat-card>
